import { render, staticRenderFns } from "./Fragments.vue?vue&type=template&id=52158e5a&scoped=true&"
import script from "./Fragments.vue?vue&type=script&lang=js&"
export * from "./Fragments.vue?vue&type=script&lang=js&"
import style0 from "./Fragments.vue?vue&type=style&index=0&id=52158e5a&prod&scoped=true&lang=css&"
import style1 from "./Fragments.vue?vue&type=style&index=1&id=52158e5a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52158e5a",
  null
  
)

export default component.exports